// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import InteractionTwoToneSvg from "@ant-design/icons-svg/es/asn/InteractionTwoTone";
import AntdIcon from '../components/AntdIcon';

var InteractionTwoTone = function InteractionTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: InteractionTwoToneSvg
  }));
};

InteractionTwoTone.displayName = 'InteractionTwoTone';
export default React.forwardRef(InteractionTwoTone);